const en = {
  letStart: `Let's start the process of Due Diligence`,
  provideInfo: `We kindly ask you to provide us with the required information and fill in the form below. It is necessary for a preliminary assessment of the application for the chosen investment program. As a result, we will warn you about possible risks, if such are found.`,
  passportUpload: `Passport copies upload`,
  uploadCopies: `Please upload copies of all your and your family members' passports.
All previously entered information is saved, but we need passport copies to proceed. If you skip this step, we'll remind you by email to upload the documents.`,
  uploadRequirements: `Please make a color scan/image of the document bio-data page (photo and personal details). Ensure the document is complete, clear, and easily readable in PDF, JPG, or JPEG format.`,
  loadingText: `Loading...`,
  buttonTextDD1: `Next`,
  buttonTextDD2: `Submit`,
  applicants: [
    `Main Applicant`,
    `Second member`,
    `Third member`,
    `Fourth member`,
    `Fifth member`,
    `Sixth member`,
    `Seventh member`,
    `Eighth member`,
    `Ninth member`,
    `Tenth member`,
    `Eleventh member`,
  ],
};
export const dueDiligenceFormDict = {
  en,
};
